import React, { useState } from "react";
import Position from "./position.tsx";
import styles from "./footer.module.scss";

export default function Footer() {
  return (
    <>
      <div className={styles.footerLayout}>
        <img
          src="../linkedin_logo.svg"
          alt="LinkedIn account"
          onClick={() =>
            window.open("https://www.linkedin.com/in/rapolas-skripkauskas/")
          }
          className={styles.socialMedia}
          id={styles.linkedIn}
        />
        <img
          src="../instagram.svg"
          alt="LinkedIn account"
          onClick={() => window.open("https://www.instagram.com/rapol4s/")}
          className={styles.socialMedia}
          id={styles.instagram}
        />
      </div>
    </>
  );
}
